module.exports = __webpack_public_path__ + "static/img/tips.b6fec54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot/tips.png
// module id = mPay
// module chunks = 1